import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const THEMEN = [
  {
    tag: "Farbe",
    title: "Balayage",
    ist: "Eine Freihand-Farbtechnik in Toupier-Technik: Die Strähnen werden leicht toupiert, die Farbe sanft aufgetragen und in Folien gewickelt – dadurch entstehen besonders weiche, natürliche Übergänge.",
    macht: "Lässt das Haar aussehen wie von der Sonne geküsst, wächst ohne sichtbaren Ansatz heraus und braucht weniger Nachfärben als klassische Farbe.",
    preis: "ab 120 €",
    link: "/balayage",
    linkLabel: "Alles über Balayage",
  },
  {
    tag: "Festliche Frisuren",
    title: "Hochsteckfrisuren & Braut",
    ist: "Elegante Frisuren für Hochzeit, Konfirmation und besondere Anlässe – abgestimmt auf Kleid, Anlass und Ihre Persönlichkeit.",
    macht: "Sie fühlen sich bei Ihrem großen Tag rundum wohl: Auf Wunsch mit Probe-Termin, damit vorher alles sitzt und Sie entspannt feiern können.",
    preis: "nach Absprache",
    link: "/hochsteckfrisuren",
    linkLabel: "Alles über Braut-Styling",
  },
  {
    tag: "Schnitt & Pflege",
    title: "Lockiges Haar",
    ist: "Ein Spezialschnitt für Naturlocken: Die Locken werden nass geschnitten – Strähne für Strähne, damit die Form perfekt sitzt.",
    macht: "Ihre Locken fallen definiert und gesund, springen besser und lassen sich zu Hause viel leichter in Form bringen.",
    preis: "ab 35 €",
    link: "/lockiges-haar",
    linkLabel: "Alles über Locken",
  },
  {
    tag: "Länge & Fülle",
    title: "Haar-Extensions",
    ist: "Hochwertige Echthaar-Strähnen, die nahtlos ins eigene Haar eingearbeitet werden – nach ausführlicher Beratung zu Methode und Pflege.",
    macht: "Mehr Länge und Fülle in einem Termin – das eigene Haar wirkt voller und länger, ganz ohne wochenlanges Warten.",
    preis: "ab 150 €",
    link: "/haar-extensions",
    linkLabel: "Alles über Extensions",
  },
];

const KURZ = [
  {
    tag: "Für alle",
    title: "Der richtige Haarschnitt",
    text: "Ein guter Schnitt ist das Fundament: Er passt zur Gesichtsform, zum Alltag und dazu, wie viel Zeit Sie morgens investieren möchten. Bei Nes bekommen Damen, Herren und Kinder Schnitte, die auch nach Wochen noch gut aussehen – inklusive ehrlicher Beratung, was zu Ihrem Haar wirklich funktioniert.",
    preis: "ab 18 €",
  },
  {
    tag: "Volumen & Wellen",
    title: "Dauerwelle",
    text: "Die moderne Dauerwelle ist schonend und sieht natürlich aus: Sie gibt feinem Haar dauerhaft Volumen, Griffigkeit und sanfte Wellen – morgens weniger Styling, trotzdem gepflegt. Als Komplett-Paket mit Schnitt, Kur und Föhnen 110 €.",
    preis: "ab 70 €",
  },
];

export default function Frisuren() {
  return (
    <div data-testid="page-frisuren">
      <section className="py-16 md:py-20 border-b border-[#24211D]/10">
        <div className="max-w-6xl mx-auto px-6">
          <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Einfach erklärt</span>
          <h1 className="text-[clamp(36px,4.5vw,64px)] leading-tight mb-6">Frisuren & Wissen.</h1>
          <p className="text-base text-[#24211D]/80 max-w-2xl leading-relaxed">
            Was ist eigentlich eine Balayage? Was bringt eine Dauerwelle? Hier erklären wir in einfachen Worten, was unsere wichtigsten Leistungen sind und was sie für Ihr Haar tun – damit Sie genau wissen, was zu Ihnen passt.
          </p>
        </div>
      </section>

      <section className="py-16 border-b border-[#24211D]/10">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8">
          {THEMEN.map((t, i) => (
            <Reveal key={t.title} delay={i * 0.08} className="h-full">
              <div className="border border-[#24211D]/15 bg-[#FFFFFF] p-8 flex flex-col h-full hover:border-[#B08D57]/50 transition-colors duration-300" data-testid={`frisuren-card-${i}`}>
                <span className="text-[10px] uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">{t.tag}</span>
                <h2 className="text-2xl mb-4">{t.title}</h2>
                <p className="text-xs text-[#24211D]/75 leading-relaxed font-sans mb-3"><b className="text-[#24211D]">Was ist das?</b> {t.ist}</p>
                <p className="text-xs text-[#24211D]/75 leading-relaxed font-sans mb-6 flex-1"><b className="text-[#24211D]">Was bringt es?</b> {t.macht}</p>
                <div className="pt-5 border-t border-[#24211D]/10 flex items-center justify-between">
                  <span className="text-sm font-sans font-bold">{t.preis}</span>
                  <Link to={t.link} data-testid={`frisuren-link-${i}`} className="text-xs uppercase tracking-widest text-[#B08D57] hover:text-[#24211D] font-sans transition-colors duration-200">
                    {t.linkLabel} →
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-16 border-b border-[#24211D]/10 bg-[#F4EFE6]">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8">
          {KURZ.map((t, i) => (
            <Reveal key={t.title} delay={i * 0.08} className="h-full">
              <div className="border-t border-[#B08D57]/40 pt-6 h-full flex flex-col" data-testid={`frisuren-kurz-${i}`}>
                <span className="text-[10px] uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">{t.tag}</span>
                <h2 className="text-2xl mb-4">{t.title}</h2>
                <p className="text-xs text-[#24211D]/75 leading-relaxed font-sans mb-4 flex-1">{t.text}</p>
                <span className="text-sm font-sans font-bold">{t.preis}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <span className="text-xs uppercase tracking-[0.2em] text-[#B08D57] block mb-2 font-sans">Unsicher, was passt?</span>
          <h2 className="text-3xl md:text-4xl mb-4">Lassen Sie sich kostenlos beraten.</h2>
          <p className="text-sm text-[#24211D]/75 font-sans leading-relaxed mb-8">
            Sie müssen vorher nichts wissen – Nes schaut sich Ihr Haar an, hört zu und sagt ehrlich, was am besten zu Ihnen passt. Ohne Verkaufsdruck.
          </p>
          <Link to="/kontakt#termin" data-testid="frisuren-beratung-btn" className="bg-[#B08D57] hover:bg-[#967442] text-[#FBF8F3] px-8 py-4 text-xs uppercase tracking-[0.18em] font-sans transition-[transform,background-color] duration-300 hover:-translate-y-1 inline-block">
            Beratungstermin anfragen
          </Link>
        </div>
      </section>
    </div>
  );
}
